import React from "react";
import GroupList from "components/common/dl_group/GroupList/GroupList";
import styled from "styled-components";
import {
  DL_GROUP_DESCRIPTION,
  DlGroupDescription,
} from "constant/dl_group/dl_group_description.constant";
import { DL_GROUP_SLUG } from "constant/dl_group/dl_group.constant";

const artistsData: DlGroupDescription[] = [
  DL_GROUP_DESCRIPTION[DL_GROUP_SLUG.PetarLubarda],
  DL_GROUP_DESCRIPTION[DL_GROUP_SLUG.SavaSumanovic],
  DL_GROUP_DESCRIPTION[DL_GROUP_SLUG.NadezdaPetrovic],
];

console.log("artistsData", artistsData);

const Artists: React.FC = () => {
  return (
    <Container>
      <Title>UMETNICI</Title>
      <GroupList groupsData={artistsData} />;
    </Container>
  );
};

const Container = styled.div`
  padding: 2rem;
`;

export const Title = styled.div`
  font-family: Verdana, Arial, sans-serif;
  font-size: 1rem;
  font-weight: bold;
  margin-bottom: 2rem;
`;

export default Artists;
